import './App.css';
import Visualizer from './Visualizer'

function App() { 
  return (
    <>
      <Visualizer />
    </>
  )
}

export default App;
